import {
  Document,
  ImageRun,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  WidthType,
  BorderStyle,
  TextRun,
} from 'docx'
import { saveAs } from 'file-saver'
import { DOC_WIDTH } from './const.js'
import { checkNullorEmptyObj, createVehicleData } from './util.js'

export const buildReport = (
  mapBlob,
  attacks,
  selectedAttack,
  selectedScenarioId
) => {
  let attackSections = []
  attacks
    .filter(
      attack =>
        attack.original_id &&
        attack.active &&
        attack.scenario_id === selectedScenarioId
    )
    .forEach(item => {
      const selected =
        !checkNullorEmptyObj(selectedAttack) && selectedAttack.id === item.id
      const attack = {
        ...item,
        selected,
      }
      attackSections.push(spacer())
      attackSections.push(attackSection(attack))
    })

  return new Document({
    sections: [
      {
        children: [mapPara(mapBlob), ...attackSections],
      },
    ],
  })
}

export const attackSection = attack => {
  const rows = []
  rows.push(attackSectionRow(attack, 'HEADER'))
  rows.push(attackSectionRow(attack, 'SUMMARY'))
  rows.push(attackSectionRow(attack, 'VEHICLE_HEADER'))
  createVehicleData(attack).forEach(vehicleDataItem => {
    rows.push(attackSectionRow(vehicleDataItem, 'VEHICLE_TYPE_SUMMARY', attack))
  })
  return new Table({
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: rows,
  })
}

export const attackSectionRow = (dataItem, rowType, parentAttack) => {
  let parentVehicle
  switch (rowType) {
    case 'VEHICLE_TYPE_SUMMARY':
      parentVehicle = dataItem.vehicle === parentAttack.vehicle
      return new TableRow({
        children: [
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: dataItem.vehicle,
                    color: parentVehicle ? 'FF0000' : '000000',
                  }),
                ],
              }),
            ],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: dataItem.mass.toString(),
                    color: parentVehicle ? 'FF0000' : '000000',
                  }),
                ],
              }),
            ],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: dataItem.end_speed.toString(),
                    color: parentVehicle ? 'FF0000' : '000000',
                  }),
                ],
              }),
            ],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: dataItem.energy.toString(),
                    color: parentVehicle ? 'FF0000' : '000000',
                  }),
                ],
              }),
            ],
          }),
        ],
      })
    case 'VEHICLE_HEADER':
      return new TableRow({
        children: [
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph(`Vehicle Type`)],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph(`Vehicle Mass (${dataItem.units.massUnits})`),
            ],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph(`Attack Speed (${dataItem.units.speedUnits})`),
            ],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph(`Attack Energy (kJ)`)],
          }),
        ],
      })
    case 'SUMMARY':
      return new TableRow({
        children: [
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph(`Total Length (${dataItem.units.distanceUnits})`),
            ],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph(dataItem.path_length.toString())],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph(`Starting Speed (${dataItem.units.speedUnits})`),
            ],
          }),
          new TableCell({
            width: {
              size: 25,
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph(dataItem.start_speed.toString())],
          }),
        ],
      })
    case 'HEADER':
      return new TableRow({
        children: [
          new TableCell({
            columnSpan: [4],
            width: {
              size: 100,
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: dataItem.name,
                    color: dataItem.selected ? 'FF0000' : '000000',
                  }),
                ],
              }),
            ],
          }),
        ],
      })
    default:
      return null
  }
}

export const mapPara = mapBlob => {
  return new Paragraph({
    border: border,
    children: [
      new ImageRun({
        data: mapBlob,
        transformation: {
          width: docImageDimensions().width,
          height: docImageDimensions().height,
        },
      }),
    ],
  })
}

export const spacer = () => {
  return new Paragraph({
    text: ' ',
    spacing: {
      after: 400,
    },
  })
}

export const saveDocumentToFile = (doc, fileName) => {
  const mimeType =
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  Packer.toBlob(doc).then(blob => {
    const docblob = blob.slice(0, blob.size, mimeType)
    saveAs(docblob, fileName)
  })
}

const docImageDimensions = () => {
  const ratio = DOC_WIDTH / window.innerWidth
  const height = window.innerHeight * ratio
  return {
    width: DOC_WIDTH,
    height,
  }
}

const border = {
  top: {
    color: 'auto',
    space: 1,
    style: BorderStyle.SINGLE,
    size: 6,
  },
  bottom: {
    color: 'auto',
    space: 1,
    style: BorderStyle.SINGLE,
    size: 6,
  },
  left: {
    color: 'auto',
    space: 1,
    style: BorderStyle.SINGLE,
    size: 6,
  },
  right: {
    color: 'auto',
    space: 1,
    style: BorderStyle.SINGLE,
    size: 6,
  },
}
